// Vidéos d'ambiance (19/10) : emplacements mf-slot et grand visuel de l'accueil.
// - lecture seulement quand la vidéo est à l'écran (rien n'est chargé avant : preload none), pause sinon ;
// - une seule version jouée selon la largeur : .mf-vid--mob (< 750 px) ou .mf-vid--desk ;
// - « réduire les animations » (réglage du téléphone) : pas de lecture, l'image d'affiche reste ;
// - apparition en fondu à la première lecture (classe mf-vid--wait, CSS dans mf-refonte.css).
// Chargé par snippets/mf-slot.liquid et sections/mf-hero.liquid (plusieurs balises possibles : garde ci-dessous).
(function () {
  if (window.mfVideo) return;
  window.mfVideo = true;
  var mobile = window.matchMedia('(max-width: 749px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var vids = [];

  function wanted(v) {
    if (v.classList.contains('mf-vid--mob')) return mobile.matches;
    if (v.classList.contains('mf-vid--desk')) return !mobile.matches;
    return true;
  }
  function onScreen(v) {
    var r = v.getBoundingClientRect();
    return r.width > 0 && r.bottom > -150 && r.top < window.innerHeight + 150 && r.right > 0 && r.left < window.innerWidth;
  }
  // apparition en fondu (19/10, « les vidéos apparaissent de façon brusque ») : invisible jusqu'à la première image jouée
  function shown(v) {
    v.classList.remove('mf-vid--wait');
    v.mfShown = true;
  }
  function prepare(v) {
    if (v.mfReady) return;
    v.mfReady = true;
    if (still.matches) return; // pas de lecture : l'affiche reste visible
    v.classList.add('mf-vid--wait');
    // 27/10 (cliente : « la vidéo apparaît hachée ») : on attend qu'elle avance vraiment (0,3 s jouées),
    // pas la 1re image : au téléphone elle s'arrêtait aussitôt pour charger la suite, d'où l'effet saccadé
    function avance() {
      if (v.currentTime < 0.3) return;
      v.removeEventListener('timeupdate', avance);
      shown(v);
    }
    v.addEventListener('timeupdate', avance);
  }
  // 21/10 (vitesse) : aucune vidéo ne démarre avant que la page soit entièrement chargée (photos, styles, scripts) ;
  // la même vidéo, même qualité, part juste un peu après. En attendant, l'image de l'affiche est visible.
  var loaded = document.readyState === 'complete';
  function go() {
    if (loaded) return;
    loaded = true;
    sync();
  }
  window.addEventListener('load', function () { setTimeout(go, 300); });
  setTimeout(go, 6000); // filet : une ressource lente ne doit pas bloquer la vidéo

  // 21/10 (vitesse) : affiche (data-poster) chargée seulement pour la version jouée, à moins de deux écrans
  function poster(v) {
    var src = v.getAttribute('data-poster');
    if (!src || !wanted(v)) return;
    var r = v.getBoundingClientRect();
    if (r.width > 0 && r.top < window.innerHeight * 2 && r.bottom > -window.innerHeight) {
      v.setAttribute('poster', src);
      v.removeAttribute('data-poster');
    }
  }
  function sync() {
    if (!loaded) return;
    vids.forEach(poster);
    vids.forEach(function (v) {
      if (!still.matches && wanted(v) && onScreen(v)) {
        if (v.paused) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () { shown(v); });
        }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }
  function init() {
    vids = Array.prototype.slice.call(document.querySelectorAll('video.mf-vid'));
    vids.forEach(prepare);
    sync();
  }
  // setTimeout plutôt que requestAnimationFrame : rAF ne tourne pas dans un onglet caché
  var t = 0;
  function soon() {
    if (t) return;
    t = setTimeout(function () {
      t = 0;
      sync();
    }, 120);
  }
  // capture : attrape aussi le défilement horizontal des carrousels (frise)
  window.addEventListener('scroll', soon, { passive: true, capture: true });
  window.addEventListener('resize', soon);
  if (mobile.addEventListener) {
    mobile.addEventListener('change', sync);
    still.addEventListener('change', sync);
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
